import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AuditListService } from './api/auditList.service';
import { AuthorizationService } from './api/authorization.service';
import { AuthorizationPasswordService } from './api/authorizationPassword.service';
import { CompanyUserService } from './api/companyUser.service';
import { LaboratoryService } from './api/laboratory.service';
import { NormService } from './api/norm.service';
import { PositionService } from './api/position.service';
import { RoleService } from './api/role.service';
import { UserService } from './api/user.service';
import { WorkspaceService } from './api/workspace.service';
import { WorkspaceUserService } from './api/workspaceUser.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
